import {toString} from 'es-toolkit/compat'

import * as optionApi from '../../../services/api/option'
import {
  factorToPercentageString,
  isMixedValue,
  percentageStringToFactor,
  toNumberValue,
  toPossiblyMixedValue,
  toStringValue,
} from '../../utils/form'

import {OptionWithLinkedProviderInfos, Provider} from '../../../types'

import {MixedFormData, SingleFormData} from './form'

// FormData Infills to optionApi Infills

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formDataTransforms: Record<string, (value: any) => any> = {
  name: name => name,
  type: type => type,
  basePrice: toNumberValue,
  productionTimeFastOffset: toNumberValue,
  productionTimeSlowOffset: toNumberValue,
  factor: percentageStringToFactor,
}

export const formDataToInfillRequest = (
  formData: SingleFormData,
  provider: Provider
): optionApi.OptionRequest => ({
  name: formDataTransforms.name(formData.name),
  type: formDataTransforms.type(formData.type),
  factor: formDataTransforms.factor(formData.factor),
  basePrice: formDataTransforms.basePrice(formData.basePrice),
  productionTimeFastOffset: formDataTransforms.productionTimeFastOffset(
    formData.productionTimeFastOffset
  ),
  productionTimeSlowOffset: formDataTransforms.productionTimeSlowOffset(
    formData.productionTimeSlowOffset
  ),
  productionTimeFastTotal: null,
  productionTimeSlowTotal: null,
  materialId: null,
  provider: provider.id,
})

export const formDataToPartialInfillRequest = (formData: Partial<SingleFormData>) => {
  const infillRequest: Partial<optionApi.OptionRequest> = {}

  Object.keys(formData).forEach(key => {
    const value = formData[key as keyof SingleFormData]
    const infillRequestTransform = formDataTransforms[key]

    if (!isMixedValue(value) && infillRequestTransform) {
      infillRequest[key as keyof optionApi.OptionRequest] = infillRequestTransform(value)
    }
  })

  return infillRequest
}

// optionApi Infills to FormData Infills

export const infillsToFormData = (infills: OptionWithLinkedProviderInfos[]): MixedFormData => ({
  name: toPossiblyMixedValue(
    infills.map(pricing => pricing.name),
    toString
  ),
  type: toPossiblyMixedValue(
    infills.map(pricing => pricing.type),
    toString
  ),
  factor: toPossiblyMixedValue(
    infills.map(pricing => pricing.factor),
    factorToPercentageString
  ),
  basePrice: toPossiblyMixedValue(
    infills.map(pricing => pricing.basePrice),
    toStringValue
  ),
  productionTimeFastOffset: toPossiblyMixedValue(
    infills.map(pricing => pricing.productionTimeFastOffset),
    toStringValue
  ),
  productionTimeSlowOffset: toPossiblyMixedValue(
    infills.map(pricing => pricing.productionTimeSlowOffset),
    toStringValue
  ),
})
